var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FF3D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04127 11.11C6.3971 11.11 5.83127 11.0147 5.34378 10.824C4.86501 10.6333 4.49069 10.3583 4.22083 9.99899C3.95968 9.63965 3.8291 9.21799 3.8291 8.73399H5.43519C5.43519 9.09332 5.57882 9.37932 5.86609 9.59199C6.16206 9.80465 6.55379 9.91099 7.04127 9.91099C7.51135 9.91099 7.88131 9.80465 8.15117 9.59199C8.42973 9.37932 8.56902 9.10065 8.56902 8.75599C8.56902 8.49199 8.48196 8.25732 8.30786 8.05199C8.13376 7.84665 7.87696 7.71099 7.53746 7.64499L6.25782 7.36999C5.57012 7.22332 5.02605 6.94832 4.62562 6.54499C4.22518 6.14165 4.02497 5.66132 4.02497 5.10399C4.02497 4.64932 4.14248 4.25332 4.37752 3.91598C4.62126 3.57865 4.96076 3.31832 5.39602 3.13499C5.83997 2.95165 6.35793 2.85999 6.94987 2.85999C7.55052 2.85999 8.07283 2.95165 8.51678 3.13499C8.96074 3.31832 9.30459 3.57865 9.54834 3.91598C9.80078 4.24599 9.92701 4.63465 9.92701 5.08198H8.33398C8.33398 4.76665 8.20775 4.51732 7.95531 4.33399C7.70286 4.14332 7.36771 4.04799 6.94987 4.04799C6.54073 4.04799 6.21429 4.14332 5.97055 4.33399C5.73551 4.51732 5.61799 4.75932 5.61799 5.05999C5.61799 5.30932 5.70069 5.51465 5.86609 5.67599C6.04019 5.83732 6.27958 5.95465 6.58426 6.02799L7.90308 6.30299C8.60819 6.44965 9.16096 6.74299 9.56139 7.18299C9.97053 7.62299 10.1751 8.14732 10.1751 8.75599C10.1751 9.23265 10.0445 9.64699 9.78337 9.99899C9.53093 10.351 9.16967 10.626 8.69959 10.824C8.22952 11.0147 7.67674 11.11 7.04127 11.11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShort);
export default __webpack_public_path__ + "static/media/short.2a2dc7453b332d7c8765d332ffe8c941.svg";
export { ForwardRef as ReactComponent };